import { render, staticRenderFns } from "./ProjectFeedsSubmissionForm.vue?vue&type=template&id=25ae4eea"
import script from "./ProjectFeedsSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectFeedsSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports